<style scoped>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
.required_err {
  color: rgba(255, 0, 0);
}

.br_tbl_td_bottom {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.br_tbl_td_no_borders {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: none !important;
}

tr:hover {
    background-color: transparent !important;
}

.br_rd_odd {
    background-color: rgba(0, 0, 0, .03) !important;
}

.rc_section {
    padding-top: 12px;
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
    <div class="ip_pool">
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">IPoE profiles</h2></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="show_new_item_form"
                    color="primary" dark class="mb-2">
                    Add IPoE profile
            </v-btn>
        </v-toolbar>

        <v-simple-table>
            <template v-slot:default>

<v-dialog v-model="dialog" max-width="600px">
    <ValidationObserver ref="edit_item_observer" v-slot="{ invalid }">
    <v-card>
        <v-card-title>
            <span class="headline">IPoE Profile ID {{ edited_item.id }}</span>
        </v-card-title>

        <v-card-text>
            <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                    <v-col cols="12">
                        <ValidationProvider rules="numeric|required" v-slot="{ errors }">
                            <v-text-field
                                v-model="edited_item.radius_client_id"
                                label="Radius client id">
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider rules="" v-slot="{ errors }">
                            <v-text-field
                                v-model="edited_item.name"
                                label="Profile name (optional)">
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <div class="rc_section">
                            <div class="rc_section">
                                <v-toolbar flat>
                                    <v-toolbar-title>DHCP pools</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="add_dhcp_pool()">Add</v-btn>
                                </v-toolbar>
                                <v-data-table
                                        :headers="dhcp_pool_hdrs"
                                        :items="edited_item.dhcp_pools"
                                        sort-by="name"
                                        hide-default-footer
                                        class="elevation-1">
                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small @click="before_del_dhcp_pool(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <template v-slot:no-data>
                                        No records
                                    </template>
                                </v-data-table>
                            </div>

                            <div class="rc_section">
                                <v-toolbar flat>
                                    <v-toolbar-title>VLAN sets</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="vlan_set__show_add_form()">Add</v-btn>
                                </v-toolbar>
                                <v-data-table
                                        :headers="vlan_set_hdrs"
                                        :items="edited_item.vlan_sets"
                                        sort-by="vlan_set_id"
                                        hide-default-footer
                                        class="elevation-1">
                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small @click="vlan_set__before_del(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <template v-slot:no-data>
                                        No records
                                    </template>
                                </v-data-table>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" :disabled="invalid" text @click="save">Save</v-btn>
            <v-btn color="blue darken-1" text @click="close">Close</v-btn>
        </v-card-actions>
    </v-card>
    </ValidationObserver>
</v-dialog>

<v-dialog v-model="new_item_dialog" max-width="500px">
    <ValidationObserver ref="new_item_observer" v-slot="{ invalid }">
        <v-card>
            <v-card-title>
                <span class="headline">Add a new IPoE profile</span>
            </v-card-title>
            <v-card-text>
                <v-container style="height: 520px; overflow-y: scroll;">
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                                <v-text-field
                                    v-model="profile_id"
                                    label="IPoE profile ID">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </v-col>
                    </v-row>  
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="new_item_form__close">
                    Cancel</v-btn>
                <v-btn color="blue darken-1" :disabled="invalid"
                        text @click="new_item_form__save">
                    Save</v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</v-dialog>

<v-dialog v-model="new_dhcp_pool_dialog" max-width="500px">
    <div>
        <dhcp_pool_box v-model="show_dhcp_pool_form"
            @canceled="dhcp_pool_form__on_cancel" 
            @selected="dhcp_pool_form__on_select($event)">
        </dhcp_pool_box>
    </div>

    <ValidationObserver ref="new_dhcp_pool_observer" v-slot="{ invalid }">
        <v-card>
            <v-card-title>
                <span class="headline">Add a new DHCP pool to IPoE profile {{ edited_item.id }}</span>
            </v-card-title>
            <v-card-text>
                <v-container style="height: 520px; overflow-y: scroll;">
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-text-field v-model="dhcp_pool_name"
                                        label="DHCP pool name">
                                    <template #append>
                                        <v-btn @click="open_dhcp_pools_form()">...</v-btn>
                                    </template>                          
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </v-col>
                    </v-row>  
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="new_dhcp_pool_form__close">
                    Cancel</v-btn>
                <v-btn color="blue darken-1" :disabled="invalid"
                        text @click="new_dhcp_pool_form__save">
                    Save</v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</v-dialog>

<v-dialog v-model="new_vlan_set_dialog" max-width="500px">
    <div>
        <vlan_set_box v-model="show_vlan_set_form"
            @canceled="vlan_set__on_cancel"
            @selected="vlan_set__on_select($event)">
        </vlan_set_box>
    </div>

    <ValidationObserver ref="new_vlan_set_observer" v-slot="{ invalid }">
        <v-card>
            <v-card-title>
                <span class="headline">Add VLAN set to PPPoE profile {{ edited_item.id }}</span>
            </v-card-title>
            <v-card-text>
                <v-container style="height: 520px; overflow-y: scroll;">
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-text-field v-model="vlan_set_id"
                                        label="VLAN Set ID">
                                    <template #append>
                                        <v-btn @click="open_vlan_sets_form()">...</v-btn>
                                    </template>                          
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </v-col>
                    </v-row>  
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="vlan_set__close_form">
                    Cancel</v-btn>
                <v-btn color="blue darken-1" :disabled="invalid"
                        text @click="vlan_set__save_form">
                    Save</v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</v-dialog>

            <thead>
                <tr>
                    <th class="text-left">
                        ID
                    </th>
                    <th class="text-left">
                        Profile name
                    </th>
                    <th class="text-left">
                        Radius Client Id
                    </th>
                    <th class="text-left">
                        DHCP pools
                    </th>
                    <th class="text-left">
                        VLAN sets
                    </th>
                    <th class="text-left">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-for="item,row_ind in items">
                    <tr v-for="(n,ind) in item.num_rows" :key="item.id + ':' + n">
                        <td v-if="ind == 0" :class="tbl_td_class_w_name('br_tbl_td_bottom', row_ind)" 
                            @dblclick="edit_item(item)"
                            :rowspan="item.num_rows">
                                {{ item.id }}
                        </td>

                        <td v-if="ind == 0" :class="tbl_td_class_w_name('br_tbl_td_bottom', row_ind)" 
                            @dblclick="edit_item(item)"
                            :rowspan="item.num_rows">
                                {{ item.name }}
                        </td>

                        <td v-if="ind == 0" :class="tbl_td_class_w_name('br_tbl_td_bottom', row_ind)" 
                            @dblclick="edit_item(item)"
                            :rowspan="item.num_rows">
                                {{ item.radius_client_id }}
                        </td>

                        <td :class="tbl_td_class(item, ind, row_ind)" v-if="item.dhcp_pools[ind] !== undefined"
                                @dblclick="edit_item(item)">
                            {{ item.dhcp_pools[ind].name }}
                        </td>
                        <td :class="tbl_td_class(item, ind, row_ind)" @dblclick="edit_item(item)" v-else>
                        </td>

                        <td :class="tbl_td_class(item, ind, row_ind)" v-if="item.vlan_sets[ind] !== undefined"
                                @dblclick="edit_item(item)">
                            {{ item.vlan_sets[ind].id }}
                        </td>
                        <td :class="tbl_td_class(item, ind, row_ind)" @dblclick="edit_item(item)" v-else>
                        </td>

                        <td v-if="ind == 0" 
                                :class="tbl_td_class_w_name('br_tbl_td_bottom', row_ind)" 
                                :rowspan="item.num_rows">
                            <v-icon small class="me-2" @click="edit_item(item)">
                                mdi-pencil
                            </v-icon>
                            <v-icon small @click="before_delete_item(item)">
                                mdi-delete
                            </v-icon>
                        </td>                        
                    </tr>
                </template>
            </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>

import api_client from '../services/api.js';
import vif_ip_addr_box from "../components/vif_ip_addr_box.vue";
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import dhcp_pool_box from "../components/dhcp_pool_box.vue";
import vlan_set_box from "../components/vlan_set_box.vue";
import "../validation_rules.js"

export default {
    name: 'ipoe_profile',
    components: { 
        ValidationObserver, ValidationProvider, vif_ip_addr_box, dhcp_pool_box,
        vlan_set_box
    },

    data: () => ({
        deleted_ip_pool_range: {},

        edited_item: {
        },
        items: [],
        dialog: false,

        profile_id: '',
        new_item_dialog: false,

        dhcp_pool_hdrs: [
            { text: 'DHCP pool name', value: 'name', align: 'start' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],

        vlan_set_hdrs: [
            { text: 'VLAN set id', value: 'id', align: 'start' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],

        dhcp_pool_name: '',
        new_dhcp_pool_dialog: false,
        
        vlan_set_id: '',
        new_vlan_set_dialog: false,

        show_dhcp_pool_form: false,
        show_vlan_set_form: false,
    }),

    created() {
        this.initialize();
    },

    methods: {
        tbl_td_class_w_name(class_name, row_ind) {
            if (row_ind % 2 == 1)
                return class_name + " br_rd_odd";
            return class_name;
        },

        tbl_td_class(item, ind, row_ind) {
            let add_class = "";

            if (row_ind % 2 == 1) {
                add_class = " br_rd_odd";
            }

            if (ind === item.num_rows - 1) {
                return "br_tbl_td_bottom" + add_class;
            }

            return "br_tbl_td_no_borders" + add_class;
        },

        calculate_fields() {
            this.items.forEach(item => {
                let l = 1;

                l = Math.max(l, item.dhcp_pools.length);
                l = Math.max(l, item.vlan_sets.length);

                item["num_rows"] = l;
            });
        },

        initialize() {
            return new Promise((resolve, reject) => {
                api_client.run_get_query("/ipoe/profiles")
                .then(response => {
                    this.items = response.data;
                    this.calculate_fields();
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                });
            });
        },

        update_edited_item() {
            this.items.forEach(item => {
                if (item.id === this.edited_item.id) {
                    this.edited_item = Object.assign({}, item);
                }
            });
        },

        edit_item(item) {
            this.edited_item = Object.assign({}, item);
            this.dialog = true;
        },

        delete_item() {
            api_client.run_post_query("/ipoe/profile/destroy", {
                id: this.edited_item.id
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    /* success */
                    this.initialize();
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });            
        },

        before_delete_item(item) {
            this.edited_item = Object.assign({}, item);
            this.$confirm("Are you sure you want to destroy IPoE profile id '" + item.id + "' ?")
            .then(() => {
                this.delete_item()
            });
        },

        close() {
            this.dialog = false;
            this.initialize();
        },

        show_new_item_form() {
            this.profile_id = '';
            requestAnimationFrame(() => {
                this.$refs.new_item_observer.reset();
            });          
            this.new_item_dialog = true;
        },

        close_item_pool_form() {
            this.new_item_dialog = false;
        },
        
        new_item_form__close() {
            this.new_item_dialog = false;
        },

        new_item_form__save() {
            this.$refs.new_item_observer.validate().then(obs_result => {
                if (!obs_result) {
                    this.$fire({title: "Warning", 
                        text: "Can't save due to invalid field values", type: "warning"});
                    return;
                }

                api_client.run_post_query("/ipoe/profile/create", {
                    id: this.profile_id
                })
                .then(response => {
                    if (response.data.hasOwnProperty("err_msg")) {
                        this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                    }
                    else {
                        /* success */
                        this.new_item_form__close();
                        this.initialize();
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$fire({title: "Command failed", text: error, type: "warning"});
                });
            });
        },

        /*
         * DHCP pools
         */

        dhcp_pool_delete() {
            api_client.run_post_query("/ipoe/profile/dhcp_pool_del", {
                id: this.edited_item.id,
                dhcp_pool_name: this.dhcp_pool_name,
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.initialize().then(value => {
                        this.update_edited_item();
                    });
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        before_del_dhcp_pool(item) {
            this.dhcp_pool_name = item.name;
            this.$confirm("Are you sure you want to delete DHCP pool ''" + 
                item.name + "'' from IPoE profile " + this.edited_item.id + "?")
            .then(() => {
                this.dhcp_pool_delete();
            });
        },

        add_dhcp_pool() {
            this.ip_pool_name = '';
            requestAnimationFrame(() => {
                this.$refs.new_dhcp_pool_observer.reset();
            });
            this.new_dhcp_pool_dialog = true;
        },

        new_dhcp_pool_form__close() {
            this.new_dhcp_pool_dialog = false;
        },

        new_dhcp_pool_form__save() {
            api_client.run_post_query("/ipoe/profile/dhcp_pool_add", {
                id: this.edited_item.id,
                dhcp_pool_name: this.dhcp_pool_name,
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.initialize().then(value => {
                        this.update_edited_item();
                        this.new_dhcp_pool_form__close();
                    });
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        /*
         * VLAN set
         */

        vlan_set__delete() {
            api_client.run_post_query("/ipoe/profile/vlan_set_del", {
                id: this.edited_item.id,
                vlan_set_id: this.vlan_set_id,
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.initialize().then(value => {
                        this.update_edited_item();
                    });
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        vlan_set__before_del(item) {
            this.vlan_set_id = item.id;
            this.$confirm("Are you sure you want to delete VLAN set " + 
                item.id + " from IPoE profile " + this.edited_item.id + "?")
            .then(() => {
                this.vlan_set__delete();
            });
        },

        vlan_set__show_add_form() {
            this.vlan_set_id = '';
            requestAnimationFrame(() => {
                this.$refs.new_vlan_set_observer.reset();
            });
            this.new_vlan_set_dialog = true;
        },

        vlan_set__close_form() {
            this.new_vlan_set_dialog = false;
        },

        vlan_set__save_form() {
            api_client.run_post_query("/ipoe/profile/vlan_set_add", {
                id: this.edited_item.id,
                vlan_set_id: this.vlan_set_id,
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.initialize().then(value => {
                        this.update_edited_item();
                        this.vlan_set__close_form();
                    });
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        /*
         * Update profile options
         */
        save() {
            let opts = {
                id: this.edited_item.id,
            };

            opts["radius_client_id"] = this.edited_item.radius_client_id;
            if (this.edited_item.name !== undefined && this.edited_item.name !== null && this.edited_item.name !== "") {
                opts["name"] = this.edited_item.name;
            }

            api_client.run_post_query("ipoe/profile/set_opts", opts)
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.initialize();
                    this.dialog = false;
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });            
        },

        open_dhcp_pools_form() {
            this.show_dhcp_pool_form = true;
        },

        dhcp_pool_form__on_cancel() {
            this.show_dhcp_pool_form = false;
        },

        dhcp_pool_form__on_select(ip_pool_name) {
            this.dhcp_pool_name = ip_pool_name;
            this.show_dhcp_pool_form = false;
        },

        open_vlan_sets_form() { 
            this.show_vlan_set_form = true;
        },

        vlan_set__on_cancel() {
            this.show_vlan_set_form = false;
        },

        vlan_set__on_select(vlan_set_id) {
            this.vlan_set_id = vlan_set_id;
            this.show_vlan_set_form = false;
        },
    }
};
</script>
